// extracted by mini-css-extract-plugin
export default {"wrapperClass":"aKrTBR4KEoH2SwLeWQHq"};